/* Ver como a cliente (Caio, 25/10/2026). So na pagina Meus favoritos, aberta pelo link do painel (ver, ts, sig, n).
   Mostra a lista da cliente como ela ve no site, so para olhar: nada e gravado e a lista deste aparelho nao muda. */
(function () {
  'use strict';
  if (location.pathname.indexOf('/pages/favoritos') !== 0) return;
  var p = new URLSearchParams(location.search);
  var cid = p.get('ver') || '', ts = p.get('ts') || '', sig = (p.get('sig') || '').toLowerCase();
  if (!/^\d{5,20}$/.test(cid) || !/^\d{9,11}$/.test(ts) || !/^[a-f0-9]{64}$/.test(sig)) return;
  var nome = (p.get('n') || '').slice(0, 80) || 'cliente';
  var itens = [], contato = false;
  var nada = function () {};
  window.MTFav = {
    itens: function () { return itens.slice(); },
    tem: function (v) { return itens.some(function (i) { return String(i.v) === String(v); }); },
    adicionar: nada, remover: nada, trocar: nada, abrirConvite: nada,
    temContato: function () { return contato; },
    sincronizar: function () { return Promise.resolve(); },
    pagina: '/pages/favoritos', ver: true
  };
  document.documentElement.classList.add('mt-ver-carregando');
  /* a lista deste aparelho pode ja ter sido desenhada: redesenha vazia ate chegar a da cliente */
  document.dispatchEvent(new CustomEvent('mt-fav:mudou'));
  var css = document.createElement('style');
  css.textContent = '.mt-ver-carregando [data-mt-favs-vazio]{display:none!important}' +
    '.mt-ver-faixa{background:#fdeceb;border:1px solid #f3a9ab;color:#201e1d;padding:12px 16px;margin:0 0 20px;font-size:14px;line-height:1.5}' +
    '.mt-ver-faixa b{font-weight:600}.mt-ver [data-mt-favs-tirar]{pointer-events:none;opacity:.35}';
  document.head.appendChild(css);
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function faixa(html) {
    var raiz = document.querySelector('[data-mt-favs]');
    if (!raiz) return;
    var f = raiz.querySelector('.mt-ver-faixa');
    if (!f) {
      f = document.createElement('div'); f.className = 'mt-ver-faixa'; f.setAttribute('role', 'status');
      raiz.insertBefore(f, raiz.firstChild); raiz.classList.add('mt-ver');
    }
    f.innerHTML = html;
  }
  function iniciar() {
    faixa('Carregando os favoritos de <b>' + esc(nome) + '</b>...');
    fetch('https://n8n.michellet.com.br/webhook/favoritos', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ acao: 'ver', chave: 'c:' + cid, cid: cid, ts: ts, sig: sig, gid: '' })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (r) {
        document.documentElement.classList.remove('mt-ver-carregando');
        if (!r || !r.ok || !Array.isArray(r.itens)) {
          faixa('Não deu para abrir esta lista. O link pode ter vencido: atualize o painel e clique de novo em <b>ver como a cliente</b>.');
          return;
        }
        itens = r.itens; contato = !!r.contato;
        faixa('Você está vendo os favoritos de <b>' + esc(nome) + '</b> do jeito que ela vê no site. Só para olhar: nada muda na lista dela.');
        document.dispatchEvent(new CustomEvent('mt-fav:mudou'));
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
